"use client"

import { useState } from "react"
import TaskForm from "./components/TaskForm"
import TaskColumn from "./components/TaskColumn"
import "./App.css"

function App() {
  const [tasks, setTasks] = useState([])
  const [editingTask, setEditingTask] = useState(null)

  const projects = ["Project Gamma", "Project Beta", "Project Alpha", "E-commerce Platform", "Mobile Banking App"]

  // Add new task
  const addTask = (taskData) => {
    const newTask = {
      id: Date.now(),
      ...taskData,
      status: "Pending",
    }
    setTasks([...tasks, newTask])
  }

  // Update existing task
  const updateTask = (updatedTask) => {
    const updatedTasks = tasks.map((task) => (task.id === updatedTask.id ? updatedTask : task))
    setTasks(updatedTasks)
    setEditingTask(null)
  }

  // Move task to next status
  const moveTask = (taskId, newStatus) => {
    const updatedTasks = tasks.map((task) => (task.id === taskId ? { ...task, status: newStatus } : task))
    setTasks(updatedTasks)
  }

  // Start editing a task
  const startEdit = (task) => {
    setEditingTask(task)
  }

  // Cancel editing
  const cancelEdit = () => {
    setEditingTask(null)
  }

  // Get tasks by status
  const pendingTasks = tasks.filter((task) => task.status === "Pending")
  const workingTasks = tasks.filter((task) => task.status === "Working")
  const completedTasks = tasks.filter((task) => task.status === "Completed")

  return (
    <div className="app">
      {/* Header */}
      <div className="header">
        <h1>Task Management Application</h1>
      </div>

      <div className="main-container">
        {/* Left Side - Form */}
        <div className="form-container">
          <TaskForm
            onSubmit={editingTask ? updateTask : addTask}
            onCancel={editingTask ? cancelEdit : null}
            projects={projects}
            editingTask={editingTask}
            isEditing={!!editingTask}
          />
        </div>

        {/* Right Side - Task Columns */}
        <div className="columns-container">
          <TaskColumn
            title="Pending"
            tasks={pendingTasks}
            onMoveTask={moveTask}
            onEditTask={startEdit}
            showEditButton={true}
          />
          <TaskColumn title="Working" tasks={workingTasks} onMoveTask={moveTask} showEditButton={false} />
          <TaskColumn title="Completed" tasks={completedTasks} onMoveTask={moveTask} showEditButton={false} />
        </div>
      </div>
    </div>
  )
}

export default App
